import { storeTheme, ThemeClass } from '@store/debugger';
import { elements } from '@utilities/dom';

import { THEME_CLASSES } from './constants';

export function changeTheme(element: HTMLElement) {
    const selectInput = element.querySelector('#select-theme') as HTMLSelectElement;
    storeTheme(selectInput.value as ThemeClass);
}

export function resetThemeClasses() {
    THEME_CLASSES.forEach((themeClass) => {
        elements.body.classList.remove(themeClass);
    });
}

export function updateBodyThemeClass(selectedTheme: ThemeClass | undefined) {
    if (selectedTheme) elements.body.classList.add(`${selectedTheme}`);
}
